<template lang="pug">
</template>

<script>
import clone from "just-clone";
import {debounce} from "@/utils";

const defaultSort = { field: null, isDesc: false, queryParam: null }

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    sortBy: {
      type: String,
      default: null
    },
    isDesc: {
      type: Boolean,
    },
    headers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sort: clone(defaultSort)
    }
  },
  watch: {
    sortBy(value) {
      this.handleSortBy(value)
    },
    isDesc(value) {
      this.handleSortDesc(value)
    }
  },
  methods: {
    handleSortBy(sortBy) {
      this.sort.field = sortBy ?? null
      this.handleSortQueryParam()
    },
    handleSortDesc(isDesc) {
      this.sort.isDesc = isDesc ?? false
      this.handleSortQueryParam()
    },
    handleSortQueryParam: debounce(function () {
      const selectedField = this.headers.find(item => item.value === this.sort.field)
      if (selectedField && selectedField.sort_query_param) {
        if (Array.isArray(selectedField.sort_query_param)) {
          this.sort.queryParam = selectedField.sort_query_param.map(item => this.createSortQueryParam(item)).join(',')
        }
        if (typeof selectedField.sort_query_param === 'string') {
          this.sort.queryParam = this.createSortQueryParam(selectedField.sort_query_param)
        }
        this.$emit('input', this.sort.queryParam)
        return
      }
      this.sort.queryParam = null
      this.$emit('input', null)
    }, 100),
    createSortQueryParam(queryParam) {
      if (this.sort.isDesc) {
        queryParam = `-${queryParam}`
      }
      return queryParam
    }
  },
}
</script>

<style scoped>

</style>